
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class ListAppPurOrderDialog extends Serenity.EntityDialog<ListAppPurOrderRow, any> {
        protected getFormKey() { return ListAppPurOrderForm.formKey; }
        protected getIdProperty() { return ListAppPurOrderRow.idProperty; }
        protected getLocalTextPrefix() { return ListAppPurOrderRow.localTextPrefix; }
        protected getNameProperty() { return ListAppPurOrderRow.nameProperty; }
        protected getService() { return ListAppPurOrderService.baseUrl; }
        protected getDeletePermission() { return ListAppPurOrderRow.deletePermission; }
        protected getInsertPermission() { return ListAppPurOrderRow.insertPermission; }
        protected getUpdatePermission() { return ListAppPurOrderRow.updatePermission; }

        protected form = new ListAppPurOrderForm(this.idPrefix);

    }
}